import React from 'react'
import { SvgIcon } from '@material-ui/core'

function SearchIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle
        id='Ellipse 7'
        cx='10.8'
        cy='10.8'
        r='6'
        fill='none'
        stroke='#444444'
        stroke-width='1.6'
      />
      <line
        id='Line 3'
        x1='15.3313'
        y1='15.3335'
        x2='19.8666'
        y2='19.8688'
        stroke='#444444'
        stroke-width='1.6'
        stroke-linecap='round'
      />
    </SvgIcon>
  )
}

export default SearchIcon
